import React from "react";
import { useAppContext } from "../../Context/AppContext/AppContext";
import { Tabs } from "antd";
import { useSearchParams } from "react-router-dom";
import { useJobApplications } from "../../Hooks/useJobApplications";
import { getPageMetaData } from "../../Utils/meta-data";
import PageMetadata from "../../Components/PageMetaData/PageMetaData";
import JobPostListingHeroSection from "./components/JobPostListingHeroSection";
import { useAuth } from "../../Context/AuthContext/AuthContext";
import AllOpenings from "./components/AllOpenings";
import SavedApplications from "./components/SavedApplications";
import UserNotice from "../../Components/UserNotice/UserNotice";
import "./index.scss";

const JobPostListingPage: React.FC = () => {
  const { isUserLoggedIn } = useAuth();
  const { organization, isBasePlanExpired } = useAppContext();
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = (searchParams.get("tab") || "openings") as
    | "openings"
    | "saved";

  const { jobApplications } = useJobApplications();

  const handleTabChange = (key: string) => {
    setSearchParams({ tab: key }, { replace: true });
  };

  const tabContent =
    activeTab === "openings" ? (
      <AllOpenings jobApplications={jobApplications} />
    ) : (
      <SavedApplications jobApplications={jobApplications} />
    );

  const items = [
    {
      key: "openings",
      label: "Open Positions",
      children: tabContent,
    },
  ];

  if (isUserLoggedIn) {
    items.push({
      key: "saved",
      label: "Saved Applications",
      children: tabContent,
    });
  }
  const meta = organization
    ? getPageMetaData("listing", { organization })
    : getPageMetaData("listing");

  return (
    <div className="job-listing">
      <PageMetadata title={meta.title} description={meta.description} />

      {!isBasePlanExpired && <JobPostListingHeroSection />}

      {isBasePlanExpired ? (
        <UserNotice
          organization={organization}
          isBasePlanExpired={isBasePlanExpired}
          isNoJobPosts={false}
          asSection={true}
        />
      ) : (
        <section className="job-listing__section">
          <div className="job-listing__card">
            <Tabs
              activeKey={activeTab}
              onChange={handleTabChange}
              className="job-listing__tabs"
              items={items}
            />
          </div>
        </section>
      )}
    </div>
  );
};

export default JobPostListingPage;
